import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';

export const withRouter = (component: () => React.ReactNode) => () => {
	return (
		<BrowserRouter>
			<Suspense
				fallback={
					<Box w="full" h="full" display="flex">
						<Spinner size="xl" m="auto" />
					</Box>
				}
			>
				{component()}
			</Suspense>
		</BrowserRouter>
	);
};
